<template>
    <div class="min-h-screen flex flex-col ">
        <Modal :show-modal="$store?.modals.resetPasswordModal || false" @cancel="closeModal">
            <template v-slot:header>
                <p class="text-xl font-bold text-main-color">{{ $t('action.changepassword') }}</p>
            </template> 
            <template v-slot:content>
                <Form @submit="changePassword" :validation-schema="passwordResetSchema()">
                    <div class="mt-5 flex flex-col gap-2">
                        <label for="newPassword" class="text-start font-semibold text-main-color">{{ $t('form.newPassword') }}</label>
                        <Field v-model="formPasswordReset.newPassword" name="newPassword" id="newPassword" cols="20" rows="3"
                                class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4">
                        </Field>
                        <ErrorMessage name="newPassword" class="text-red-500"></ErrorMessage>

                    </div>
                    <div class="mt-5 flex flex-col gap-2">
                        <label for="confirmPassword" class="text-start font-semibold text-main-color">{{ $t('form.passwordRepeat') }}</label>
                        <Field v-model="formPasswordReset.confirmPassword" name="confirmPassword" id="confirmPassword" cols="20" rows="3"
                                class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4">
                        </Field>
                        <ErrorMessage name="confirmPassword" class="text-red-500"></ErrorMessage>
                    </div>
                    <div class="mt-5 flex gap-5">
                        <SubmitBtn type="submit" class="text-base" :loading="loading">{{ $t('action.renewPassword') }}</SubmitBtn>
                        <button @click="closeModal" class="w-full text-main-color font-bold">
                            {{ $t('action.cancel') }}</button>
                    </div>
                </Form>
            </template>
        </Modal>
        <TopHeader class="max-lg:hidden" />
        <div class="container">
            <ProfileHeader class="max-lg:mt-5" />
            <main class="flex-auto max-md:px-3.75">
                <router-view />
            </main>
        </div>
        <TheFooter></TheFooter>
    </div>
	<PageUpButton />
</template>

<script>

import TopHeader from '@/components/TopHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import ProfileHeader from '@/components/profile/ProfileHeader.vue'
import { passwordResetSchema } from '@/schemas'
import { Field, Form, ErrorMessage } from 'vee-validate';
import Modal from '@cmp/Modal.vue'
import api from '@/api';
import { i18n } from '@/i18n'
import PageUpButton from '@/components/PageUpButton.vue'

export default {
    name: 'ProfileLayout',
    components: {
        TopHeader,
        ProfileHeader,
        TheFooter,
        Modal,
        Field, Form, ErrorMessage,
        PageUpButton
    },
    data(){
        return {
            loading: false,
            passwordResetSchema: passwordResetSchema,
            passwordResetField: null,
            formPasswordReset: {
                newPassword: null,
                confirmPassword: null
            },
        }
    },
    methods: {
        closeModal(){
            this.$store.modals.resetPasswordModal = false
        },
        async changePassword(){
            try{
                const response = await api.patch('users/me/', { password: this.formPasswordReset.newPassword })
                this.$toast.info(`${i18n.global.t('warning.PASSWORD_UPDATED')}`)
                
            }catch(e){
                console.log()
            }
        },
        async getSubscriptionData(){
            try {
                const response = await api.get('commercials/subscriptions/')
                this.$store.subscriptionSettings = response.data
            } catch (e) {
                console.error('Error fetching subscription data:', e)
            }
        }


    },
    computed: {

    },
    async mounted(){
        await this.getSubscriptionData()
    }
}

</script>



